import React, { useState } from "react";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import Flex from "../../../../../DefaultStyles/Flex";
import AlertModal from "../../../../../Modal/AlertModal";
import { HasInitValueBox } from "../../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import PopupActModal from "./PopupActModal";

interface PopupActSectionProps {
  modalType?: string;
  popupAct?: number;
  popupId?: number;
  confirmEvent: () => void;
  user?: string;
}

export default function PopupActSection({
  modalType,
  popupAct,
  popupId,
  confirmEvent,
  user,
}: PopupActSectionProps) {
  const [askPopupAct, setAskPopupAct] = useState(false);
  const [popupActModal, setPopupActModal] = useState(false);

  return (
    <>
      <ModalRow>
        <ModalLabel>처리 여부</ModalLabel>

        <Flex gapSize={10}>
          <HasInitValueBox style={{ width: popupAct === 0 ? 220 : 230 }}>
            {popupAct === 0 ? "미완료" : popupAct === 1 ? "완료" : "-"}
          </HasInitValueBox>

          <>
            {popupAct === 0 && (
              <ConfirmBtn
                btnText="팝업완료"
                btnColor="mint"
                btnHeight={38}
                isDisabled={modalType === "view"}
                btnClickEvent={() => setAskPopupAct(true)}
              />
            )}
          </>
        </Flex>
      </ModalRow>

      {askPopupAct && (
        <AlertModal
          title={`${user ?? ""}님의
        팝업 상태가 완료로 변경됩니다.
        계속 하시겠습니까?`}
          cancelEvent={() => setAskPopupAct(false)}
          confirmEvent={() => {
            setAskPopupAct(false);
            setPopupActModal(true);
          }}
        />
      )}

      {popupActModal && (
        <PopupActModal
          closeEvent={() => setPopupActModal(false)}
          confirmEvent={() => confirmEvent()}
          popupId={popupId}
        />
      )}
    </>
  );
}
